import { types } from "./nodes/types";
import { Comment } from "./nodes/Comment";
import { TextNode } from "./nodes/TextNode";
export const nodeOps = (stage) => ({
    insert: (child, parent, anchor) => {
        if (anchor != null) {
            parent._insertBefore(child, anchor);
        }
        else {
            parent._appendChild(child);
        }
    },
    remove: (child) => {
        const parent = child.parent;
        if (parent != null) {
            parent._removeChild(child);
        }
    },
    createElement: (tag, isSVG) => {
        let type = types[tag];
        if (!type) {
            console.warn(`Unknown native tag: ${tag}`);
            type = types["container"];
        }
        return new type(stage);
    },
    createText: (text) => {
        return new TextNode(text);
    },
    createComment: (text) => {
        return new Comment(text);
    },
    setText: (node, text) => {
        // Noop
    },
    setElementText: (node, text) => {
        node.setElementText(text);
    },
    parentNode: (node) => (node.parent ? node.parent : null),
    nextSibling: (node) => node.nextSibling,
    querySelector: (selector) => {
        var _a;
        if (selector.startsWith("#")) {
            selector = selector.substr(1);
        }
        return ((_a = stage.getById(selector)) === null || _a === void 0 ? void 0 : _a.data) || null;
    },
});
//# sourceMappingURL=nodeOps.js.map